import { useEffect } from 'react';
import { useRunningWebLock, useSignalR } from '@s20/hooks/signalr.hooks';

export const DispatchHub = ({
    onJobCreated,
    onJobUpdated,
    onSendMultipleOperations,
    onJobCancellationUpdated,
    onJobsUpdatedBulk,
    onJobDeleted,
    onStaffRelatedDataUpdated,
    onReconnect,
}) => {
    const hub = useSignalR('legacyDispatchHub', { onReconnect });
    useRunningWebLock('legacyDispatchHub');

    useEffect(() => {
        if (hub) {
            hub.on('JobCreated', (json) => {
                onJobCreated(json);
            });

            hub.on('JobUpdated', (json) => {
                onJobUpdated(json);
            });

            hub.on('SendMultipleOperations', (json) => {
                onSendMultipleOperations(json);
            });

            hub.on('JobCancellationUpdated', (json) => {
                onJobCancellationUpdated(json);
            });

            hub.on('JobsUpdatedBulk', (json) => {
                onJobsUpdatedBulk(json);
            });

            hub.on('JobDeleted', (json) => {
                onJobDeleted(json);
            });

            hub.on('StaffRelatedDataUpdated', (json) => {
                onStaffRelatedDataUpdated(json);
            });

            try {
                hub.invoke('JoinGroup', 'Dispatch')
                    .then(() => {
                    })
                    .catch((e) => {
                        console.info('Unable to join dispatch hub', e);
                    });
            } catch (e) {
                console.info(e);
            }

            return () => {
                hub.off('JobCreated');
                hub.off('JobUpdated');
                hub.off('SendMultipleOperations');
                hub.off('JobCancellationUpdated');
                hub.off('JobsUpdatedBulk');
                hub.off('JobDeleted');
                hub.off('StaffRelatedDataUpdated');
            };
        }

        return undefined;
    }, [hub, onJobCancellationUpdated, onJobCreated, onJobDeleted, onJobUpdated, onJobsUpdatedBulk, onReconnect, onSendMultipleOperations, onStaffRelatedDataUpdated]);

    return null;
};